import React from 'react'

import arrowedLinkStyles from "./ArrowedLink.module.css"

import linkArrow from "../../images/link-arrow.png"

export default function ArrowedLink({ children, url, title }) {
    return(       
        <a href={url} title={title} className={arrowedLinkStyles.container}>
            {children}
            <img src={linkArrow} alt="Link" />
        </a>
    )
}